import { useAppConfigContext } from '@/context/AppConfig';
import { Text, Box, Button, Modal } from '@/theme/index';

type ClearAllNotificationsModalProps = {
  /** If true, the modal is open */
  isOpen: boolean;
  /** Uncontrolled function for changing the value of 'isOpen' */
  setIsOpen: (isOpen: boolean) => void;
  /** Function for clearning all notifications */
  clearAllNotifications: () => void;
};

export const ClearAllNotificationsModal = ({
  isOpen,
  setIsOpen,
  clearAllNotifications,
}: ClearAllNotificationsModalProps) => {
  const { trackEventGA4 } = useAppConfigContext();
  const closeModal = () => setIsOpen(false);

  const handleClearAllNotifications = () => {
    trackEventGA4({
      event_name: 'feature_Engagement',
      type: 'clear_all',
      interacted_from: 'notifications',
    });

    clearAllNotifications();
    closeModal();
  };

  return (
    <Modal
      open={isOpen}
      onClose={() => setIsOpen(false)}
      maxWidth={false}
      data-testid="clear-all-notifications-modal"
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            minWidth: '320px',
            maxWidth: '320px',
          },
          '& .MuiDialogContent-root': {
            padding: '16px 20px',
          },
        },
      }}
    >
      <Box display="flex" flexDirection="column">
        <Text variant="h3" textAlign="center" mb={3}>
          Are you sure you want to clear all notifications?
        </Text>
        <Box display="flex" justifyContent="space-between">
          <Button
            variant="outlined"
            color="success"
            size="medium"
            onClick={closeModal}
            sx={{ fontSize: '0.875rem', width: '135px' }}
          >
            No, thank you
          </Button>
          <Button
            variant="contained"
            color="success"
            size="medium"
            onClick={handleClearAllNotifications}
            sx={{ fontSize: '0.875rem', width: '135px' }}
          >
            Yes, continue
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
